import './accordion.css';

import { DsIcon } from '@descomplica/design-system-react';
import React from 'react';

import { ButtonContainer } from '@/presentation/shared-components/button';

export type ConditionalLabel = {
  open: string;
  close: string;
};

type AccordionParams = {
  open: boolean;
  accordionTitle: React.ReactNode;
  additionalInfo?: React.ReactNode;
  toggleAccordion: () => void;
  children: React.ReactNode;
  ariaLabel: ConditionalLabel;
};

export const Accordion: React.FC<AccordionParams> = ({
  open,
  accordionTitle,
  additionalInfo,
  toggleAccordion,
  children,
  ariaLabel,
}: AccordionParams) => (
  /* TODO: The accordion must become a separate component in the UI library */
  <div className="accordion">
    <ButtonContainer
      className="accordion-button"
      onClick={toggleAccordion}
      ariaLabel={open ? ariaLabel.close : ariaLabel.open}
    >
      {accordionTitle}
      <div className="accordion-info-wrapper">
        {additionalInfo}
        <DsIcon image={open ? 'arrow-drop-up' : 'arrow-drop-down'} className="accordion-dropdown" />
      </div>
    </ButtonContainer>
    <div className={`accordion-content ${open ? 'show' : 'hide'}`}>{children}</div>
  </div>
);
